import { Radio, RadioChangeEvent } from 'antd';
import React, { FC, useState } from 'react';
import { BadgeSide } from '../../../../model/BadgeModel';
import styles from './switchSideMenu.module.scss';

const { Group: RadioGroup, Button: RadioButton } = Radio;

const SwitchSideMenu: FC = () => {
	const [currentSide, setCurrentSide] = useState<BadgeSide>(BadgeSide.Front);

	const handleOnChangeView = ({ target: { value } }: RadioChangeEvent) => {
		setCurrentSide(value);
	};

	return (
		<div className={styles.switchSideBar}>
			<RadioGroup value={currentSide} onChange={handleOnChangeView} buttonStyle='solid' className={styles.switchView}>
				<RadioButton value={BadgeSide.Front}>{_('Front')}</RadioButton>
				<RadioButton value={BadgeSide.Back}>{_('Back')}</RadioButton>
			</RadioGroup>
		</div>
	);
};

export { SwitchSideMenu };
